import React from 'react'
import { AreaEditorProps, DashboardAreaKeys } from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import DashboardArea from '../DashboardArea'
import Widgets from '../Widgets'
import { DASHBOARD_EDITOR_WIDGETS_AREA_ID } from 'src/Libs/qa/ids'

/**
 * Widgets area for the dashboard editor
 */
const WidgetsArea: React.FC<AreaEditorProps> = ({
  hidden,
  setHidden,
  widgetAreasConfiguration,
  setWidgetAreasConfiguration,
  position,
  getMenuItems,
  isDynamicPowerPriceEnabled,
  disabled,
}) => {
  const { t } = useCustomTranslation()

  return (
    <DashboardArea
      areaKey={DashboardAreaKeys.widgets}
      name={t('dashboard.editor.widgets')}
      hidden={hidden}
      setHidden={setHidden}
      position={position}
      getMenuItems={getMenuItems}
      disabled={disabled}
      dataQa={DASHBOARD_EDITOR_WIDGETS_AREA_ID}
    >
      {widgetAreasConfiguration && setWidgetAreasConfiguration && (
        <Widgets
          widgetAreasConfiguration={widgetAreasConfiguration}
          setWidgetAreasConfiguration={setWidgetAreasConfiguration}
          isDynamicPowerPriceEnabled={isDynamicPowerPriceEnabled ?? false}
        />
      )}
    </DashboardArea>
  )
}

export default WidgetsArea
